import SectionTitle from 'components/atoms/SectionTitle';
import React, { useRef, useState } from 'react';
import { useMyInfo } from 'hooks';
import { encodingEucKr } from 'utils/utils';
import FontPopup from 'components/organisms/Popup/FontPopup';
import { all_click_datalayer_push, getLGLifeToolsGAProps } from '../../../utils/GAUtils';

const Tools = () => {
  const [isFontPopupOpen, setIsFontPopupOpen] = useState<boolean>(false);

  const toolsRef = useRef<HTMLDivElement>(null);
  const snsRef = useRef<HTMLDivElement>(null);
  const subRef = useRef<HTMLDivElement>(null);
  const shoppingRef = useRef<HTMLDivElement>(null);
  const { info, setIsLogin } = useMyInfo();

  return (
    <>
      <div className="content_inner">
        <div className="section faq_tools">
          <SectionTitle title="참고 사이트" />

          <div className="section_cont">
            <div className="tools_section">
              {/* <!-- tools_accor --> */}
              <div className="tools_accor is-active" ref={toolsRef}>
                <div className="tools_accor_cont">
                  {/* <!-- tools_accor_row --> */}
                  <div className="tools_accor_row">
                    <ul className="tools_accor_list">
                      <li className="tools_accor_item">
                        <a
                          href="https://brand.lg.co.kr/"
                          target="_blank"
                          className="tools_accor_link ico_link"
                          {...getLGLifeToolsGAProps({
                            dataclickarea: '참고 사이트',
                            dataclickname: 'LG Brand Guide',
                          })}
                          onClick={e => {
                            all_click_datalayer_push(e.currentTarget);
                          }}
                        >
                          LG Brand Guide
                        </a>
                      </li>
                      <li className="tools_accor_item">
                        {info && (
                          <a
                            {...getLGLifeToolsGAProps({
                              dataclickarea: 'LG스마트체',
                            })}
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              all_click_datalayer_push(e.currentTarget);
                              setIsFontPopupOpen(true);
                            }}
                            className="tools_accor_link ico_link"
                            target="_blank"
                          >
                            LG스마트체 다운로드
                          </a>
                        )}
                      </li>
                      <li className="tools_accor_item">
                        {info && (
                          <a
                            href={`http://bizring.uplus.co.kr/groupRing/login_main.do?lgNAME=${encodingEucKr(
                              info.name as string
                            )}&brand=${encodingEucKr(info.groupNm as string)}&ctn=${encodingEucKr(
                              info.phoneNum as string
                            )}`}
                            target="_blank"
                            className="tools_accor_link ico_link"
                            {...getLGLifeToolsGAProps({
                              dataclickarea: '참고 사이트',
                              dataclickname: 'LG 로고송 무료 통화연결음',
                            })}
                            onClick={e => {
                              all_click_datalayer_push(e.currentTarget);
                            }}
                          >
                            LG 로고송 무료 통화연결음
                          </a>
                        )}
                      </li>
                      <li className="tools_accor_item">
                        <a
                          {...getLGLifeToolsGAProps({
                            dataclickarea: '계열사 사업장',
                            dataclickname: '곤지암리조트',
                          })}
                          href="http://www.konjiamresort.co.kr/"
                          onClick={e => {
                            all_click_datalayer_push(e.currentTarget);
                          }}
                          target="_blank"
                          className="tools_accor_link ico_link"
                          rel="noreferrer noopener"
                        >
                          곤지암리조트
                        </a>
                      </li>
                      <li className="tools_accor_item">
                        <a
                          {...getLGLifeToolsGAProps({
                            dataclickarea: '계열사 사업장',
                            dataclickname: '곤지암 화담숲',
                          })}
                          href="http://www.hwadamsup.com/"
                          onClick={e => {
                            all_click_datalayer_push(e.currentTarget);
                          }}
                          target="_blank"
                          className="tools_accor_link ico_link"
                          rel="noreferrer noopener"
                        >
                          곤지암 화담숲
                        </a>
                      </li>
                      <li className="tools_accor_item">
                        <a
                          {...getLGLifeToolsGAProps({
                            dataclickarea: '계열사 사업장',
                            dataclickname: 'LG아트센터',
                          })}
                          href="http://www.lgart.com/"
                          onClick={e => {
                            all_click_datalayer_push(e.currentTarget);
                          }}
                          target="_blank"
                          className="tools_accor_link ico_link"
                          rel="noreferrer noopener"
                        >
                          LG아트센터
                        </a>
                      </li>
                      <li className="tools_accor_item">
                        <a
                          {...getLGLifeToolsGAProps({
                            dataclickarea: '임직원몰',
                            dataclickname: 'LG라이프케어포탈',
                          })}
                          href="http://www.lglifecare.com/"
                          onClick={e => {
                            all_click_datalayer_push(e.currentTarget);
                          }}
                          target="_blank"
                          className="tools_accor_link ico_link"
                          rel="noreferrer noopener"
                        >
                          LG라이프케어포탈
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* <!-- /tools_accor_row --> */}
                </div>
              </div>
              {/* <!-- /tools_accor --> */}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- popup: page --> */}
      {isFontPopupOpen && <FontPopup onClose={() => setIsFontPopupOpen(false)} />}
    </>
  );
};

export default Tools;
